<script>
    import Popup from "./popup.svelte";
    import {popupStore} from "../stores/popupStore";
    import {onMount} from 'svelte';
    import fetchData from "../lib/fetchData";
    import Event from "./Event.svelte";
    import {dataStore} from "../stores/dataStore";
    import {fly} from "svelte/transition";

    let swipeDirection = null;
    let search = '';
    let sessions = {};
    let sessionsNotFiltered = {};
    let halls = {};
    let hallsBackup = {};
    let program = false;
    let searching = false;
    let currentDate = '';
    let currentTime = '';
    let currentHall = '';
    let selectedItem = null;
    let language = window.location.href.split('/')[3] === 'en' ? 1 : 0;
    let roles = {};
    let diabetechDays = [];
    let salaArray = [];
    let authors = {};
    let types = {};
    let sessionsBackup = {};
    let sessionsHall = {};
    let selectedHall = '';
    let clickedDateKey = null;
    let foundDateKey = null;
    let earliestDate = null;
    let data = {};
    let dateKey;
    let dateKeyValue;
    let foundMeeting = null;
    let hallKey;
    let activeLeftItem = 0;
    let activeLeftItems = 5;
    let resultLength = 0;
    let forwardArrowDisabled = false;
    let windowWidth = window.innerWidth;
    $: hallsLength = [...new Set(salaArray)].sort().length ? [...new Set(salaArray)].sort().length : 17;
    $: tableWidth = windowWidth > 600 ? `${Math.max(100 / hallsLength, 20)}%` : '100%';
    $: visibleHalls = [...new Set(salaArray)].slice(activeLeftItem, activeLeftItems);
    let backwardArrowDisabled = true;
    let searchIn = ['authors', 'lectures', 'abstracts', 'clinicalcases'];
    let authors_names = ['authors', 'authors_pro', 'authors_contra'];
    let timeSteps = [];
    let timeStepsBackup = [];
    let res = {};
    let diabetechSessions = {};
    let filteredHours = [];
    let startX = 0;
    let startY = 0;
    let programUrl = window['program_url'] || 'https://nowoczesnadiabetologia.pl/sapi/modules/betterforms/trigger_json/6/5157.json';


    onMount(async () => {
        program = window.screen.width < 992;
        res = await fetch(programUrl);
        let jsonRes = await res.json();
        diabetechSessions = jsonRes.days;

        for (const key in jsonRes.days) {
            if (jsonRes.days.hasOwnProperty(key)) {
                diabetechDays.push(jsonRes.days[key].name);
            }
        }


        earliestDate = diabetechDays[0];
        clickedDateKey = diabetechDays[0];
        const allKeys = new Set();
        if (windowWidth < 600) {
            activeLeftItems = 1;
        }

        Object.keys(sessions).forEach(outerKey => {
            const innerObject = sessions[outerKey];
            Object.keys(innerObject).forEach(innerKey => {
                allKeys.add(innerKey);
            });
        });

        const getAllSalaValues = (data) => {
            const salaValues = [];

            Object.values(data).forEach(obj => {
                Object.values(obj.hours).forEach(hour => {
                    Object.values(hour.sessions).forEach(session => {
                        if (session.sala) salaValues.push(session.sala);
                    });
                });
            });

            return salaValues;
        }

        salaArray = getAllSalaValues(jsonRes.days);

        function getEarliestAndLatestHoursByDay(data) {
            const result = [];

            // Traverse each main object
            for (const mainKey in data) {
                const mainObj = data[mainKey];

                // Check if 'hours' exists in the main object
                if (mainObj.hours) {
                    const times = [];

                    // Collect all times for this specific day
                    for (const hourKey in mainObj.hours) {
                        const hourObj = mainObj.hours[hourKey];

                        // Check if 'name' exists and contains the hour range
                        if (hourObj.name) {
                            const [startTime, endTime] = hourObj.name.split('-');

                            // Add both start and end times to the array for this day
                            times.push(startTime, endTime);
                        }
                    }

                    // Find the earliest and latest times for this day
                    if (times.length > 0) {
                        const earliest = times.reduce((min, time) => time < min ? time : min, times[0]);
                        const latest = times.reduce((max, time) => time > max ? time : max, times[0]);

                        // Round down the earliest time to the nearest 30 minutes
                        const earliestDate = new Date(`1970-01-01T${earliest}:00`);
                        if (earliestDate.getMinutes() > 30) {
                            earliestDate.setMinutes(30);
                        } else {
                            earliestDate.setMinutes(0);
                        }

                        // If the time is already a 30-minute mark or a full hour, round down further
                        if (earliestDate.getMinutes() === 0 && earliestDate.getHours() > 0) {
                            earliestDate.setHours(earliestDate.getHours() - 1);
                            earliestDate.setMinutes(30);
                        }
                        const roundedEarliest = earliestDate.toTimeString().slice(0, 5);

                        // Round up the latest time to the next 30 minutes
                        const latestDate = new Date(`1970-01-01T${latest}:00`);
                        if (latestDate.getMinutes() > 0 && latestDate.getMinutes() <= 30) {
                            latestDate.setMinutes(30);
                        } else if (latestDate.getMinutes() > 30) {
                            latestDate.setHours(latestDate.getHours() + 1);
                            latestDate.setMinutes(0);
                        }
                        const roundedLatest = latestDate.toTimeString().slice(0, 5);

                        // Add the day's result to the array
                        result.push({
                            day: mainObj.name,
                            earliest: roundedEarliest,
                            latest: roundedLatest
                        });
                    }
                }
            }

            return result;
        }

        filteredHours = getEarliestAndLatestHoursByDay(jsonRes.days);

        filteredHours.forEach(el => {
            if (el.day === clickedDateKey) {
                timeSteps = generateTimeArray(el.earliest, el.latest);
            }
        })

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('id')) {
            const id = urlParams.get('id');
            findMeetingId(data, id)
            dateKey = foundMeeting ? foundMeeting.date : '';
            dateKeyValue = foundDateKey;
            hallKey = foundMeeting ? foundMeeting.hall : '';
            popupStore.set(true);
        }
    });

    $: if (data !== null) {
        dataStore.set(data);
    }

    function handleTouchStart(event) {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
    }

    function handleTouchEnd(event) {
        const endX = event.changedTouches[0].clientX;
        const endY = event.changedTouches[0].clientY;

        const diffX = endX - startX;
        const diffY = endY - startY;

        if (Math.abs(diffX) > Math.abs(diffY)) {
            if (diffX > 50) {
                swipeDirection = 'right';
                hallsGoBack();
            } else if (diffX < -50) {
                swipeDirection = 'left';
                hallsGoForward();
            }
            setTimeout(() => {
                swipeDirection = null; // Reset after animation
            }, 300);
        }
    }

    function findMeetingId(data, targetId) {
        if (data.sessions) {
            for (const date in data.sessions) {
                for (const time in data.sessions[date]) {
                    for (const hall of Object.entries(data.sessions[date][time])) {
                        if (hall[1][0].id === targetId.toString()) {
                            foundDateKey = time;
                            foundMeeting = hall[1][0];
                            return hall.id;
                        }
                    }
                }
            }
        }
        return null;
    }

    function generateTimeArray(startTime, endTime) {
        function timeToMinutes(time) {
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
        }

        function minutesToTime(minutes) {
            const hours = String(Math.floor(minutes / 60)).padStart(2, '0');
            const mins = String(minutes % 60).padStart(2, '0');
            return `${hours}:${mins}`;
        }

        const startMinutes = timeToMinutes(startTime);
        const endMinutes = timeToMinutes(endTime);
        const halfHourStep = 10;
        const timeArray = [];

        for (let minutes = startMinutes; minutes <= endMinutes; minutes += halfHourStep) {
            timeArray.push(minutesToTime(minutes));
        }

        return timeArray;
    }

    const openPopup = (e, eventId) => {
        e.preventDefault();
        popupStore.set(true);
        // const newURL = window.location.href+= `?id=${eventId}`;
        // window.history.pushState({ path: newURL }, '', newURL);
        const url = new URL(window.location.href);
        url.searchParams.set('id', eventId);
        window.history.pushState(null, '', url.toString());
    }

    $: isPopupOpen = false;

    popupStore.subscribe(value => {
        isPopupOpen = value;
    });

    const handleChangeDate = (dateKey, dateValue) => {
        clickedDateKey = dateKey;
        filteredHours.forEach(el => {
            if (el.day === clickedDateKey) {
                timeSteps = generateTimeArray(el.earliest, el.latest);
            }
        })
    };


    const hallsGoBack = () => {
        if (salaArray) {
            if (windowWidth > 600) {
                activeLeftItem -= 5;
                activeLeftItems -= 5;
            } else {
                setTimeout(() => {
                    activeLeftItem -= 1;
                    activeLeftItems -= 1;
                }, 300)
            }
            backwardArrowDisabled = false;
            if (activeLeftItem <= 0) {
                if (windowWidth > 600) {
                    activeLeftItem = 0;
                    activeLeftItems = 5;
                } else {
                    activeLeftItem = 0;
                    activeLeftItems = 1;
                }
                backwardArrowDisabled = true;
                forwardArrowDisabled = false;
            }
            forwardArrowDisabled = false;
        }
    }

    const hallsGoForward = () => {
        if (salaArray) {
            const hallsLength = [...new Set(salaArray)].sort().length;
            if (windowWidth > 600) {
                if (activeLeftItems < hallsLength) {
                    activeLeftItem += 1;
                    activeLeftItems += 1;
                } else {

                    activeLeftItem = hallsLength - 1
                    activeLeftItems = hallsLength

                }
            } else {
                if (activeLeftItems < hallsLength) {
                    setTimeout(() => {
                        activeLeftItem += 1;
                        activeLeftItems += 1;
                    }, 300)
                }
            }

            backwardArrowDisabled = false;
            forwardArrowDisabled = activeLeftItems >= hallsLength;
        }
    }

    function timeToMinutes(time) {
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
    }

    function isExactMatch(timeStart, step, interval = 10) {
        const startMinutes = timeToMinutes(timeStart);
        const stepMinutes = timeToMinutes(step);
        const halfInterval = interval / 2;

        return startMinutes >= (stepMinutes - halfInterval) && startMinutes < (stepMinutes + halfInterval);
    }


    function handleEventClick(_clickedDateKey, _dateKeyValue, _hallKey, e, eventId) {
        dateKey = _clickedDateKey;
        dateKeyValue = _dateKeyValue;
        hallKey = _hallKey;

        // set new data before opening
        openPopup(e, eventId);
    }

    const idIsFound = () => {
        return true;
    }

    function updateWidth() {
        windowWidth = window.innerWidth;
        tableWidth = windowWidth > 600 ? `${Math.max(100 / hallsLength, 20)}%` : '100%';
        activeLeftItems = windowWidth > 600 ? activeLeftItem + 5 : activeLeftItem + 1;
    }

    // Update width on window resize
    window.addEventListener('resize', updateWidth);
</script>

{#if isPopupOpen && idIsFound()}
    <!--    <div class="background_color"></div>-->
    <Popup {dateKey} {dateKeyValue} {hallKey} {diabetechSessions}/>
{/if}

<!--<svelte:options customElement="program-new" />-->
<div class={`${isPopupOpen ? "darkenBackground" : ""}`}>
    <div class={`programme ${swipeDirection === 'left' ? 'swipe-left' : ''} ${swipeDirection === 'right' ? 'swipe-right' : ''}`}>
        {#if sessions && salaArray}
            <div class="w-full" on:touchstart={handleTouchStart} on:touchend={handleTouchEnd}>
                <div class="day-tabs" role="tablist">
                    {#each diabetechDays as dateKey, dateValue}
                        <button class="day-tab" class:selected={clickedDateKey === dateKey}
                                role="tab" aria-selected={clickedDateKey === dateKey}
                                on:click={() => handleChangeDate(dateKey, dateValue)}>{dateKey}</button>
                    {/each}
                </div>
                <table class="program-table">
                    <thead>
                    <tr>
                        <th class="table-header time-header">
                            {#if !backwardArrowDisabled}
                                <button class="hall-nav hall-nav-prev" aria-label="Poprzednie sale"
                                        on:click={() => hallsGoBack()}>
                                    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
                                        <path d="M15 18l-6-6 6-6" fill="none" stroke="currentColor" stroke-width="2.5"
                                              stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                            {/if}
                        </th>
                        {#each visibleHalls as sala, index}
                            <th class="table-header hall-header"
                                class:has-next={!forwardArrowDisabled && index === visibleHalls.length - 1}>
                                <span class="hall-name">{sala}</span>
                                {#if !forwardArrowDisabled && index === visibleHalls.length - 1}
                                    <button class="hall-nav hall-nav-next" aria-label="Następne sale"
                                            on:click={() => hallsGoForward()}>
                                        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
                                            <path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.5"
                                                  stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </button>
                                {/if}
                            </th>
                        {/each}
                    </tr>
                    <tr>
                        <td colspan={visibleHalls.length + 1} class="hint">
                            Kliknij sesję, aby zobaczyć szczegóły
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    {#each timeSteps as step}
                        <tr class="content" class:hour-start={step.endsWith(':00')}
                            class:half-hour={step.endsWith(':30')}>
                            <td class="time-step"><span>{step}</span></td>
                            {#each visibleHalls as hallKey, hallValue}
                                <td class="hall-cell"
                                    style="width: {tableWidth}; max-width: {tableWidth};"
                                    id="{hallKey} - {step}">
                                    {#each Object.entries(diabetechSessions) as [dateKey, dateValue]}
                                        {#if clickedDateKey === dateValue.name}
                                            {#each Object.entries(dateValue.hours) as [key, value]}
                                                {#each Object.entries(value.sessions) as [key, session]}
                                                    {#if session.sala === hallKey && isExactMatch(value.name.split("-")[0], step + ':00')}
                                                        <div class="event-hit" role="button" tabindex="0"
                                                             on:click={(e) => handleEventClick(clickedDateKey, key, hallKey, e, session.name)}
                                                             on:keydown={(e) => (e.key === 'Enter' || e.key === ' ') && handleEventClick(clickedDateKey, key, hallKey, e, session.name)}>
                                                            <Event startTime={value.name}
                                                                   endTime={''}
                                                                   title={session.name}
                                                                   englishTitle={''}
                                                                   typeId={null}
                                                                   types={types}
                                                                   type={session.typ}
                                                                   id={null}
                                                                   chairman=''
                                                                   wytyczne_id={null}/>
                                                        </div>
                                                    {/if}
                                                {/each}
                                            {/each}
                                        {/if}
                                    {/each}
                                </td>
                            {/each}
                        </tr>
                    {/each}
                    </tbody>
                </table>
            </div>
        {/if}
    </div>
</div>

<style>
    @import 'tailwindcss/tailwind.css';

    /*
    ! tailwindcss v3.4.7 | MIT License | https://tailwindcss.com
    */

    /*
    1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
    2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
    */

    .swipe-left {
        transition: opacity 0.3s ease-out;
        opacity: 0.1;
    }

    .swipe-right {
        transition: opacity 0.3s ease-out;
        opacity: 0.1;
    }

    *,
    ::before,
    ::after {
        box-sizing: border-box;
        /* 1 */
        border-width: 0;
        /* 2 */
        border-style: solid;
        /* 2 */
        border-color: #e5e7eb;
        /* 2 */
    }

    ::before,
    ::after {
        --tw-content: '';
    }

    /*
    1. Use a consistent sensible line-height in all browsers.
    2. Prevent adjustments of font size after orientation changes in iOS.
    3. Use a more readable tab size.
    4. Use the user's configured `sans` font-family by default.
    5. Use the user's configured `sans` font-feature-settings by default.
    6. Use the user's configured `sans` font-variation-settings by default.
    7. Disable tap highlights on iOS
    */

    html,
    :host {
        line-height: 1.5;
        /* 1 */
        -webkit-text-size-adjust: 100%;
        /* 2 */
        -moz-tab-size: 4;
        /* 3 */
        -o-tab-size: 4;
        tab-size: 4;
        /* 3 */
        font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        /* 4 */
        font-feature-settings: normal;
        /* 5 */
        font-variation-settings: normal;
        /* 6 */
        -webkit-tap-highlight-color: transparent;
        /* 7 */
    }

    /*
    1. Remove the margin in all browsers.
    2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.
    */

    body {
        margin: 0;
        /* 1 */
        line-height: inherit;
        /* 2 */
    }

    /*
    1. Add the correct height in Firefox.
    2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
    3. Ensure horizontal rules are visible by default.
    */

    hr {
        height: 0;
        /* 1 */
        color: inherit;
        /* 2 */
        border-top-width: 1px;
        /* 3 */
    }

    /*
    Add the correct text decoration in Chrome, Edge, and Safari.
    */

    abbr:where([title]) {
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
    }

    /*
    Remove the default font size and weight for headings.
    */

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-size: inherit;
        font-weight: inherit;
    }

    /*
    Reset links to optimize for opt-in styling instead of opt-out.
    */

    a {
        color: inherit;
        text-decoration: inherit;
    }

    /*
    Add the correct font weight in Edge and Safari.
    */

    b,
    strong {
        font-weight: bolder;
    }

    /*
    1. Use the user's configured `mono` font-family by default.
    2. Use the user's configured `mono` font-feature-settings by default.
    3. Use the user's configured `mono` font-variation-settings by default.
    4. Correct the odd `em` font sizing in all browsers.
    */

    code,
    kbd,
    samp,
    pre {
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
        /* 1 */
        font-feature-settings: normal;
        /* 2 */
        font-variation-settings: normal;
        /* 3 */
        font-size: 1em;
        /* 4 */
    }

    /*
    Add the correct font size in all browsers.
    */

    small {
        font-size: 80%;
    }

    /*
    Prevent `sub` and `sup` elements from affecting the line height in all browsers.
    */

    sub,
    sup {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
    }

    sub {
        bottom: -0.25em;
    }

    sup {
        top: -0.5em;
    }

    /*
    1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
    2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
    3. Remove gaps between table borders by default.
    */

    table {
        text-indent: 0;
        /* 1 */
        border-color: inherit;
        /* 2 */
        border-collapse: collapse;
        /* 3 */
    }

    /*
    1. Change the font styles in all browsers.
    2. Remove the margin in Firefox and Safari.
    3. Remove default padding in all browsers.
    */

    button,
    input,
    optgroup,
    select,
    textarea {
        font-family: inherit;
        /* 1 */
        font-feature-settings: inherit;
        /* 1 */
        font-variation-settings: inherit;
        /* 1 */
        font-size: 100%;
        /* 1 */
        font-weight: inherit;
        /* 1 */
        line-height: inherit;
        /* 1 */
        letter-spacing: inherit;
        /* 1 */
        color: inherit;
        /* 1 */
        margin: 0;
        /* 2 */
        padding: 0;
        /* 3 */
    }

    /*
    Remove the inheritance of text transform in Edge and Firefox.
    */

    button,
    select {
        text-transform: none;
    }

    /*
    1. Correct the inability to style clickable types in iOS and Safari.
    2. Remove default button styles.
    */

    button,
    input:where([type='button']),
    input:where([type='reset']),
    input:where([type='submit']) {
        -webkit-appearance: button;
        /* 1 */
        background-color: transparent;
        /* 2 */
        background-image: none;
        /* 2 */
    }

    /*
    Use the modern Firefox focus style for all focusable elements.
    */

    :-moz-focusring {
        outline: auto;
    }

    /*
    Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
    */

    :-moz-ui-invalid {
        box-shadow: none;
    }

    /*
    Add the correct vertical alignment in Chrome and Firefox.
    */

    progress {
        vertical-align: baseline;
    }

    /*
    Correct the cursor style of increment and decrement buttons in Safari.
    */

    ::-webkit-inner-spin-button,
    ::-webkit-outer-spin-button {
        height: auto;
    }

    /*
    1. Correct the odd appearance in Chrome and Safari.
    2. Correct the outline style in Safari.
    */

    [type='search'] {
        -webkit-appearance: textfield;
        /* 1 */
        outline-offset: -2px;
        /* 2 */
    }

    /*
    Remove the inner padding in Chrome and Safari on macOS.
    */

    ::-webkit-search-decoration {
        -webkit-appearance: none;
    }

    /*
    1. Correct the inability to style clickable types in iOS and Safari.
    2. Change font properties to `inherit` in Safari.
    */

    ::-webkit-file-upload-button {
        -webkit-appearance: button;
        /* 1 */
        font: inherit;
        /* 2 */
    }

    /*
    Add the correct display in Chrome and Safari.
    */

    summary {
        display: list-item;
    }

    /*
    Removes the default spacing and border for appropriate elements.
    */

    blockquote,
    dl,
    dd,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    hr,
    figure,
    p,
    pre {
        margin: 0;
    }

    fieldset {
        margin: 0;
        padding: 0;
    }

    legend {
        padding: 0;
    }

    /*
    Reset default styling for dialogs.
    */

    dialog {
        padding: 0;
    }

    /*
    Prevent resizing textareas horizontally by default.
    */

    textarea {
        resize: vertical;
    }

    /*
    1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
    2. Set the default placeholder color to the user's configured gray 400 color.
    */

    input::-moz-placeholder, textarea::-moz-placeholder {
        opacity: 1;
        /* 1 */
        color: #9ca3af;
        /* 2 */
    }

    input::placeholder,
    textarea::placeholder {
        opacity: 1;
        /* 1 */
        color: #9ca3af;
        /* 2 */
    }

    /*
    Set the default cursor for buttons.
    */

    button,
    [role="button"] {
        cursor: pointer;
    }

    /*
    Make sure disabled buttons don't get the pointer cursor.
    */

    :disabled {
        cursor: default;
    }

    /*
    1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)
    2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
       This can trigger a poorly considered lint error in some tools but is included by design.
    */

    img,
    svg,
    video,
    canvas,
    audio,
    iframe,
    embed,
    object {
        display: block;
        /* 1 */
        vertical-align: middle;
        /* 2 */
    }

    /*
    Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
    */

    img,
    video {
        max-width: 100%;
        height: auto;
    }

    /* Make elements with the HTML hidden attribute stay hidden by default */

    [hidden] {
        display: none;
    }

    *, ::before, ::after {
        --tw-border-spacing-x: 0;
        --tw-border-spacing-y: 0;
        --tw-translate-x: 0;
        --tw-translate-y: 0;
        --tw-rotate: 0;
        --tw-skew-x: 0;
        --tw-skew-y: 0;
        --tw-scale-x: 1;
        --tw-scale-y: 1;
        --tw-pan-x: ;
        --tw-pan-y: ;
        --tw-pinch-zoom: ;
        --tw-scroll-snap-strictness: proximity;
        --tw-gradient-from-position: ;
        --tw-gradient-via-position: ;
        --tw-gradient-to-position: ;
        --tw-ordinal: ;
        --tw-slashed-zero: ;
        --tw-numeric-figure: ;
        --tw-numeric-spacing: ;
        --tw-numeric-fraction: ;
        --tw-ring-inset: ;
        --tw-ring-offset-width: 0px;
        --tw-ring-offset-color: #fff;
        --tw-ring-color: rgb(59 130 246 / 0.5);
        --tw-ring-offset-shadow: 0 0 #0000;
        --tw-ring-shadow: 0 0 #0000;
        --tw-shadow: 0 0 #0000;
        --tw-shadow-colored: 0 0 #0000;
        --tw-blur: ;
        --tw-brightness: ;
        --tw-contrast: ;
        --tw-grayscale: ;
        --tw-hue-rotate: ;
        --tw-invert: ;
        --tw-saturate: ;
        --tw-sepia: ;
        --tw-drop-shadow: ;
        --tw-backdrop-blur: ;
        --tw-backdrop-brightness: ;
        --tw-backdrop-contrast: ;
        --tw-backdrop-grayscale: ;
        --tw-backdrop-hue-rotate: ;
        --tw-backdrop-invert: ;
        --tw-backdrop-opacity: ;
        --tw-backdrop-saturate: ;
        --tw-backdrop-sepia: ;
        --tw-contain-size: ;
        --tw-contain-layout: ;
        --tw-contain-paint: ;
        --tw-contain-style: ;
    }

    ::backdrop {
        --tw-border-spacing-x: 0;
        --tw-border-spacing-y: 0;
        --tw-translate-x: 0;
        --tw-translate-y: 0;
        --tw-rotate: 0;
        --tw-skew-x: 0;
        --tw-skew-y: 0;
        --tw-scale-x: 1;
        --tw-scale-y: 1;
        --tw-pan-x: ;
        --tw-pan-y: ;
        --tw-pinch-zoom: ;
        --tw-scroll-snap-strictness: proximity;
        --tw-gradient-from-position: ;
        --tw-gradient-via-position: ;
        --tw-gradient-to-position: ;
        --tw-ordinal: ;
        --tw-slashed-zero: ;
        --tw-numeric-figure: ;
        --tw-numeric-spacing: ;
        --tw-numeric-fraction: ;
        --tw-ring-inset: ;
        --tw-ring-offset-width: 0px;
        --tw-ring-offset-color: #fff;
        --tw-ring-color: rgb(59 130 246 / 0.5);
        --tw-ring-offset-shadow: 0 0 #0000;
        --tw-ring-shadow: 0 0 #0000;
        --tw-shadow: 0 0 #0000;
        --tw-shadow-colored: 0 0 #0000;
        --tw-blur: ;
        --tw-brightness: ;
        --tw-contrast: ;
        --tw-grayscale: ;
        --tw-hue-rotate: ;
        --tw-invert: ;
        --tw-saturate: ;
        --tw-sepia: ;
        --tw-drop-shadow: ;
        --tw-backdrop-blur: ;
        --tw-backdrop-brightness: ;
        --tw-backdrop-contrast: ;
        --tw-backdrop-grayscale: ;
        --tw-backdrop-hue-rotate: ;
        --tw-backdrop-invert: ;
        --tw-backdrop-opacity: ;
        --tw-backdrop-saturate: ;
        --tw-backdrop-sepia: ;
        --tw-contain-size: ;
        --tw-contain-layout: ;
        --tw-contain-paint: ;
        --tw-contain-style: ;
    }

    .visible {
        visibility: visible;
    }

    .collapse {
        visibility: collapse;
    }

    .fixed {
        position: fixed;
    }

    .absolute {
        position: absolute;
    }

    .relative {
        position: relative;
    }

    .sticky {
        position: sticky;
    }

    .inset-0 {
        inset: 0px;
    }

    .inset-x-0 {
        left: 0px;
        right: 0px;
    }

    .left-0 {
        left: 0px;
    }

    .right-0 {
        right: 0px;
    }

    .top-0 {
        top: 0px;
    }

    .top-20 {
        top: 5rem;
    }

    .z-\[150\] {
        z-index: 150;
    }

    .m-0 {
        margin: 0px;
    }

    .m-1 {
        margin: 0.25rem;
    }

    .mx-auto {
        margin-left: auto;
        margin-right: auto;
    }

    .block {
        display: block;
    }

    .flex {
        display: flex;
    }

    .table {
        display: table;
    }

    .contents {
        display: contents;
    }

    .hidden {
        display: none;
    }

    .h-\[2px\] {
        height: 2px;
    }

    .h-\[calc\(100vh-105px\)\] {
        height: calc(100vh - 105px);
    }

    .max-h-full {
        max-height: 100%;
    }

    .w-1 {
        width: 0.25rem;
    }

    .w-1\/12 {
        width: 8.333333%;
    }

    .w-1\/2 {
        width: 50%;
    }

    .w-11 {
        width: 2.75rem;
    }

    .w-11\/12 {
        width: 91.666667%;
    }

    .w-3\/4 {
        width: 75%;
    }

    .w-full {
        width: 100%;
    }

    .min-w-40 {
        min-width: 10rem;
    }

    .min-w-80 {
        min-width: 20rem;
    }

    .max-w-2xl {
        max-width: 42rem;
    }

    .flex-grow {
        flex-grow: 1;
    }

    .table-auto {
        table-layout: auto;
    }

    .border-collapse {
        border-collapse: collapse;
    }

    .transform {
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .resize {
        resize: both;
    }

    .flex-col {
        flex-direction: column;
    }

    .flex-wrap {
        flex-wrap: wrap;
    }

    .items-start {
        align-items: flex-start;
    }

    .items-center {
        align-items: center;
    }

    .justify-start {
        justify-content: flex-start;
    }

    .justify-center {
        justify-content: center;
    }

    .justify-between {
        justify-content: space-between;
    }

    .justify-evenly {
        justify-content: space-evenly;
    }

    .gap-0 {
        gap: 0px;
    }

    .gap-1 {
        gap: 0.25rem;
    }

    .gap-2 {
        gap: 0.5rem;
    }

    .overflow-y-auto {
        overflow-y: auto;
    }

    .overflow-x-hidden {
        overflow-x: hidden;
    }

    .overflow-y-hidden {
        overflow-y: hidden;
    }

    .whitespace-nowrap {
        white-space: nowrap;
    }

    .rounded-md {
        border-radius: 0.375rem;
    }

    .rounded-sm {
        border-radius: 0.125rem;
    }

    .rounded-bl {
        border-bottom-left-radius: 0.25rem;
    }

    .rounded-br {
        border-bottom-right-radius: 0.25rem;
    }

    .rounded-tl {
        border-top-left-radius: 0.25rem;
    }

    .rounded-tr {
        border-top-right-radius: 0.25rem;
    }

    .border {
        border-width: 1px;
    }

    .border-2 {
        border-width: 2px;
    }

    .border-gray-200 {
        --tw-border-opacity: 1;
        border-color: rgb(229 231 235 / var(--tw-border-opacity));
    }

    .border-gray-300 {
        --tw-border-opacity: 1;
        border-color: rgb(209 213 219 / var(--tw-border-opacity));
    }

    .border-slate-700 {
        --tw-border-opacity: 1;
        border-color: rgb(51 65 85 / var(--tw-border-opacity));
    }

    .bg-gray-400 {
        --tw-bg-opacity: 1;
        background-color: rgb(156 163 175 / var(--tw-bg-opacity));
    }

    .bg-red-100 {
        --tw-bg-opacity: 1;
        background-color: rgb(254 226 226 / var(--tw-bg-opacity));
    }

    .bg-slate-700 {
        --tw-bg-opacity: 1;
        background-color: rgb(51 65 85 / var(--tw-bg-opacity));
    }

    .bg-white {
        --tw-bg-opacity: 1;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity));
    }

    .p-2 {
        padding: 0.5rem;
    }

    .p-3 {
        padding: 0.75rem;
    }

    .p-4 {
        padding: 1rem;
    }

    .px-2 {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .px-4 {
        padding-left: 1rem;
        padding-right: 1rem;
    }

    .px-8 {
        padding-left: 2rem;
        padding-right: 2rem;
    }

    .py-1 {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .py-4 {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }

    .pl-6 {
        padding-left: 1.5rem;
    }

    .pr-1 {
        padding-right: 0.25rem;
    }

    .text-lg {
        font-size: 1.125rem;
        line-height: 1.75rem;
    }

    .text-sm {
        font-size: 0.875rem;
        line-height: 1.25rem;
    }

    .text-xl {
        font-size: 1.25rem;
        line-height: 1.75rem;
    }

    .font-semibold {
        font-weight: 600;
    }

    .italic {
        font-style: italic;
    }

    .text-white {
        --tw-text-opacity: 1;
        color: rgb(255 255 255 / var(--tw-text-opacity));
    }

    .underline {
        text-decoration-line: underline;
    }

    .opacity-80 {
        opacity: 0.8;
    }

    .shadow {
        --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
        --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }

    .shadow-xl {
        --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
        --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }

    .outline {
        outline-style: solid;
    }

    .ring-gray-500 {
        --tw-ring-opacity: 1;
        --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity));
    }

    .brightness-50 {
        --tw-brightness: brightness(.5);
        filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
    }

    .filter {
        filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
    }

    .backdrop-brightness-90 {
        --tw-backdrop-brightness: brightness(.9);
        -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
        backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
    }

    .backdrop-filter {
        -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
        backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
    }

    .transition {
        transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
        transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
        transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 150ms;
    }

    .hover\:bg-slate-50:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(248 250 252 / var(--tw-bg-opacity));
    }

    .hover\:opacity-100:hover {
        opacity: 1;
    }

    .hover\:shadow-inner:hover {
        --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
        --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }

    .focus\:bg-slate-100:focus {
        --tw-bg-opacity: 1;
        background-color: rgb(241 245 249 / var(--tw-bg-opacity));
    }

    .active\:scale-95:active {
        --tw-scale-x: .95;
        --tw-scale-y: .95;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    }

    .active\:bg-slate-100:active {
        --tw-bg-opacity: 1;
        background-color: rgb(241 245 249 / var(--tw-bg-opacity));
    }

    .active\:opacity-100:active {
        opacity: 1;
    }

    .active\:ring-2:active {
        --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
        box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
    }

    @media (min-width: 640px) {
        .sm\:w-4\/5 {
            width: 80%;
        }

        .sm\:w-full {
            width: 100%;
        }
    }

    @media (min-width: 768px) {
        .md\:w-3\/5 {
            width: 60%;
        }
    }

    @tailwind base;
    @tailwind components;
    @tailwind utilities;

    body {
        font-family: 'Roboto', sans-serif;
    }

    .navigation {
        height: 100vh;
        position: sticky;
        top: 0;
    }

    .navigation .mask {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .navigation .mask img {
        width: 50px;
        max-width: 100%;
    }

    .desc:hover {
        text-decoration: underline;
        cursor: pointer;
    }

    .event {
        position: absolute;
        width: 100%;
        background-color: rgba(255, 0, 0, 0.1);
        border: 1px solid #f00;
        box-sizing: border-box;
    }

    .legend {
        margin: 20px 0;
    }

    .print-hall {
        display: none;
    }

    #modal .title {
        font-size: 20px;
    }

    #modal .subtitle {
        font-size: 18px;
    }

    .program.table {
        /*margin-bottom: 0;*/
        table-layout: fixed;
    }

    .program tr td {
        text-align: center;
        vertical-align: bottom;
        font-size: 12px;
        /*width: calc(100% / 5);*/
    }

    .program tr td.hour,
    .program tr th.date {
        white-space: nowrap;
        width: 120px;
        vertical-align: middle;
    }

    .program .head .date {
        font-weight: bold;

    }

    .program .head .date .weekday {
        font-size: 16px;
        margin-bottom: 0;
    }

    .program .head .date .day {
        font-size: 20px;
        margin-bottom: 0;
    }

    .program .head .date .month {
        margin-bottom: 0;
    }

    .program .head th {
        text-align: center;
        vertical-align: middle;
        color: black;
    }

    .program .head th img {
        float: right;
        width: 20px;
        cursor: pointer;
    }

    .session {
        margin: 0;
        text-align: center;
    }

    .search-item {
        padding-top: 15px;
        padding-bottom: 15px;
    }


    .table-container {
        overflow-x: auto;
    }

    #program_sz .items {
        padding: 0 0 15px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: white;
    }

    #program_sz .item:not(:first-child) {
        padding-top: 15px;
    }

    #program_sz .item {
        width: 100%;
        text-align: center;
    }

    #program_sz .hall {
        display: flex;
        align-items: center;
    }

    #program_sz .current-hall {
        margin: 0 !important;
        padding: 10px 0;

    }

    #program_sz .hall .arrow {
        font-size: 25px;
    }

    #program_sz p {
        margin-bottom: 15px;
    }

    #program_sz .title {
        margin-bottom: 0 !important;
    }

    #program_sz .subtitle {
        margin-top: 5px !important;
        margin-bottom: 15px !important;
    }

    .flex {
        display: flex;
    }


    .program .head th,
    .btn-custom,
    .panel-custom > .panel-heading {
        color: white;
    }

    .m-0 {
        margin-bottom: 0 !important;
    }

    .m-1 {
        margin-bottom: 15px !important;
    }

    .btn-group-custom {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding: 0 15px;
    }

    .panel-subtitle {
        font-size: 14px;
        margin-top: 5px;
        margin-bottom: 0;
    }

    .red {
        color: red;
        font-weight: bold;
    }

    .red-border {
        border: 0 solid red;
        border-width: 0 3px 3px;
    }

    /* brightness-50 backdrop-brightness-90 */
    .darkenBackground {
        filter: brightness(.5);
        backdrop-filter: brightness(1);
        -webkit-backdrop-filter: brightness(1);
        box-shadow: 0px 0px 1px 5000px rgba(0, 0, 0, 0.5);
    }

    .backdrop {
        background-color: rgba(0, 0, 0, 0.5);
    }

    .placeholder {
        width: 25%;
        /* height: 104px; */
    }

    .background_color {
        position: fixed;
        inset: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgb(246, 246, 246);
        /* bigger than app, lesser than popup */
        z-index: 8000;
    }

    @media print {
        @page {
            size: auto;  /* auto is the initial value */
            margin: 0; /* this affects the margin in the printer settings */
        }

        html {
            margin: 0;
        }

        body {
            padding: 10mm 15mm 10mm 15mm;
        }

        .search-item {
            display: none;
        }

        .print-hall .program {
            /*page-break-before: always;*/
        }

        .print-hall .program .date .weekday,
        .print-hall .program .date .day,
        .print-hall .program .date .month {
            font-size: 14px;
            line-height: 1;
        }

        .header:not(:nth-of-type(1)) {
            page-break-before: always;
        }

        .program {
            margin-bottom: 0;
        }

        .page-program {
            display: none;
        }

        .print-hall {
            display: block;

        }
    }

    /* ---- Programme grid ---- */

    .programme {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        color: #3f3e3c;
        -webkit-font-smoothing: antialiased;
    }

    .swipe-left,
    .swipe-right {
        transition: opacity 0.3s ease-out;
        opacity: 0.1;
    }

    .day-tabs {
        position: sticky;
        top: 0;
        z-index: 102;
        display: flex;
        justify-content: center;
        gap: 4px;
        height: 3rem;
        padding: 0 8px;
        background-color: #2189a6;
    }

    .day-tab {
        position: relative;
        flex: 1 1 0;
        max-width: 360px;
        padding: 0 12px;
        color: white;
        font-size: 17px;
        font-weight: 600;
        letter-spacing: 0.01em;
        opacity: 0.75;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: opacity 0.15s ease, background-color 0.15s ease;
    }

    .day-tab:hover {
        opacity: 1;
    }

    .day-tab.selected {
        opacity: 1;
        background-color: rgba(255, 255, 255, 0.12);
    }

    .day-tab.selected::after {
        content: '';
        position: absolute;
        left: 16px;
        right: 16px;
        bottom: 0;
        height: 4px;
        border-radius: 4px 4px 0 0;
        background: white;
    }

    .day-tab:focus-visible,
    .hall-nav:focus-visible {
        outline: 3px solid white;
        outline-offset: -3px;
    }

    .program-table {
        width: 100%;
        table-layout: fixed;
        border-collapse: separate;
        border-spacing: 0;
        background: #f6f6f6;
    }

    .table-header {
        position: sticky;
        top: 3rem;
        z-index: 100;
        height: 52px;
        padding: 0 8px;
        background: white;
        border-bottom: 3px solid #2189a6;
        vertical-align: middle;
    }

    .hall-header {
        padding: 0 8px;
        text-align: center;
    }

    .hall-header.has-next {
        padding-right: 52px;
    }

    .hall-name {
        font-size: 15px;
        font-weight: 700;
        color: #3f3e3c;
    }

    .time-header {
        width: 64px;
    }

    .hall-nav {
        position: absolute;
        top: 50%;
        z-index: 101;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        transform: translateY(-50%);
        color: #3f3e3c;
        background: white;
        border: 1px solid #b3b3b3;
        border-radius: 999px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
        transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
    }

    .hall-nav:hover {
        color: white;
        background: #2189a6;
        border-color: #2189a6;
    }

    .hall-nav-prev {
        left: 12px;
    }

    .hall-nav-next {
        right: 8px;
    }

    .hint {
        position: sticky;
        top: calc(3rem + 52px);
        z-index: 99;
        padding: 6px 12px;
        font-size: 13px;
        text-align: center;
        color: #5f5e5c;
        background: #f6f6f6;
        border-bottom: 1px solid #e6e6e6;
    }

    .content {
        height: 60px;
    }

    .content > td {
        height: 60px;
        padding: 0;
        vertical-align: top;
        border-top: 1px solid #ececec;
    }

    .content.half-hour > td {
        border-top-color: #dcdcdc;
    }

    .content.hour-start > td {
        border-top-color: #c4c4c4;
    }

    .hall-cell {
        position: relative;
        border-left: 1px solid #e6e6e6;
    }

    .time-step {
        width: 64px;
        padding: 0 10px 0 6px !important;
        text-align: right;
        background: white;
        border-right: 1px solid #e6e6e6;
    }

    .time-step span {
        display: inline-block;
        transform: translateY(-50%);
        padding: 0 2px;
        font-size: 11px;
        font-weight: 500;
        color: #9a9a9a;
        font-variant-numeric: tabular-nums;
        background: white;
    }

    .content.half-hour .time-step span {
        font-size: 13px;
        font-weight: 600;
        color: #3f3e3c;
    }

    .content.hour-start .time-step span {
        font-size: 14px;
        font-weight: 700;
        color: #3f3e3c;
    }

    .content:first-child .time-step span {
        transform: none;
    }

    .event-hit {
        cursor: pointer;
    }

    .event-hit:focus {
        outline: none;
    }

    .event-hit:focus-visible :global(.event-tile) {
        outline: 3px solid #2189a6;
        outline-offset: 1px;
    }

    @media only screen and (max-width: 600px) {
        .day-tab {
            font-size: 14px;
            padding: 0 6px;
        }

        .time-header,
        .time-step {
            width: 52px;
        }

        .hall-header {
            padding: 0 52px;
        }
    }

    @media (min-width: 1000px) {
        .hall-name {
            font-size: 17px;
        }
    }

    @media print {
        .day-tabs,
        .table-header,
        .hint {
            position: static;
        }

        .hall-nav,
        .hint {
            display: none;
        }
    }
</style>
